import { useState } from "react";
import * as yup from 'yup';

const useHandleForm = (data, createCallback, modifyCallback, invalidDataCallback, isAdmin) => {

  const isCreate = !Boolean(data);

  const createInitialData = () => {

    const getInitialFieldData = (fieldName) => {
      return isCreate ? "" : data[fieldName];
    }

    const fieldNames = ["code", "text", "name"];

    return fieldNames.reduce((initialData, fieldName) => {
      return ({
        ...initialData,
        [fieldName]: getInitialFieldData(fieldName)
      })
    }, {});
  }

  const [formData, setFormData] = useState(createInitialData());

  const dataIsValid = async () => {
    const regex = /^[a-zA-Z]+[a-zA-Z0-9]*$/;

    const schema = yup.object().shape({
      code: yup.string().max(8).matches(regex).required(),
      name: yup.string().max(50).required(),
      text: yup.string().required(),
    });

    return await schema.isValid(formData).then((valid) => valid);
  }

  const submit = async () => {
    if (await dataIsValid()) {
      isCreate ? createCallback(formData) : modifyCallback(formData);
      return true;
    } else {
      invalidDataCallback();
      return false;
    }
  }

  const setFormValue = (value, fieldName) => {
    if (!isAdmin) return;
    setFormData({
      ...formData,
      [fieldName]: value
    })
  }

  return { isCreate, formData, setFormValue, submit };
}

export default useHandleForm;
